import React, { Component } from 'react';

import { trans } from '../../../../../../localization';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../../../components/Table/PageTable';
import {
  formatCurrency,
  isEmptyObject,
  parseToInt,
} from '../../../../../../utils/utils';
import OutOfStockItem from '../../components/OutOfStockItem';
import NowInput from '../../../../../../components/Common/NowInput';
import { getTotalPriceDishRejectOrder } from '../routines';

function NowInputPrice({
  value,
  handleChangePriceOrder,
  orderDishId,
  dishId,
  toppingId,
}) {
  return (
    <NowInput
      isNumberFormat
      value={value}
      numberFormatProps={{
        suffix: ` ${CONFIG.CURRENCY_SYMBOL}`,
      }}
      onChange={evt =>
        handleChangePriceOrder({
          orderDishId,
          dishId,
          toppingId,
          price: parseToInt(evt.target.value) || 0,
        })
      }
    />
  );
}

class RejectOrderDishEditTable extends Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('mod_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'dish_name',
        label: trans('mod_detail_dish_name'),
        width: '35%',
        textAlign: 'left',
      },
      {
        id: 'quantity',
        label: trans('mod_detail_quantity'),
        width: '10%',
        textAlign: 'center',
      },
      {
        id: 'unit_price',
        label: trans('mod_detail_unit_price'),
        width: '20%',
        textAlign: 'center',
      },
      {
        id: 'total_price',
        label: trans('mod_detail_total_price'),
        width: '15%',
        textAlign: 'center',
      },
      {
        id: 'out_of_stock',
        label: trans('mod_detail_edit'),
        width: '15%',
        textAlign: 'center',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  renderRow = (row, index) => {
    const {
      outOfStockOrder,
      priceUpdateOrder,
      handleOpenOutOfStockModal,
      handleChangePriceOrder,
    } = this.props;
    const { dishes: listDishPrice = [] } = priceUpdateOrder;
    const {
      out_of_stock: outOfStock,
      id: orderDishId,
      note: dishNote,
      dish,
    } = row;
    const { discount_price: discountPrice, id: dishId } = dish;
    const { dishes: listOutOfStock = [] } = outOfStockOrder;
    const currentOfStock = listOutOfStock.find(
      dishItem => dishItem.dishId === dish.id,
    );
    const isOutOfStock = !isEmptyObject(currentOfStock) ? true : outOfStock > 0;
    const outOfStockObj = {
      orderDishId,
      dishId,
    };
    const dishChange = listDishPrice.find(
      dishItem => dishItem.dishId === dishId,
    );
    const dishValue = !isEmptyObject(dishChange)
      ? dishChange.price
      : discountPrice.value;

    return (
      <PageTableRow key={orderDishId}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell textAlign="left">
          <strong className="color-black">{dish.name}</strong>
          <div className="font12">
            <i>{dishNote}</i>
          </div>
        </PageTableCell>
        <PageTableCell />
        <PageTableCell textAlign="center">
          <NowInputPrice
            value={dishValue}
            handleChangePriceOrder={handleChangePriceOrder}
            orderDishId={orderDishId}
            dishId={dishId}
          />
        </PageTableCell>
        <PageTableCell textAlign="center">
          <span className="font12">{formatCurrency(dishValue)}</span>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <OutOfStockItem
            isOutOfStock={isOutOfStock}
            handleOpenOutOfStockModal={handleOpenOutOfStockModal}
            currentOfStock={currentOfStock}
            isHaveChangeOrder
            outOfStockObj={outOfStockObj}
          />
        </PageTableCell>
      </PageTableRow>
    );
  };

  renderExtraRowInfo = () => {
    const {
      itemDish,
      outOfStockOrder,
      handleOpenOutOfStockModal,
      priceUpdateOrder,
      handleChangePriceOrder,
    } = this.props;
    const {
      id: orderDishId, options, dish, quantity: quantityDish,
    } = itemDish;
    const { id: dishId } = dish;
    const { toppings: listToppingPrice = [] } = priceUpdateOrder;

    const { toppings: listToppingOutOfStock = [] } = outOfStockOrder;

    const listTopping = options.reduce(
      (group, value) => [...group, ...value.attributes],
      [],
    );

    const totalPriceValue = getTotalPriceDishRejectOrder({
      priceUpdateOrder,
      outOfStockOrder,
      listTopping,
      itemDish,
    });

    const { dishes: listDishOutOfStock = [] } = outOfStockOrder;

    // Check out of stock
    const dishOutOfStockCurrent = listDishOutOfStock.find(
      dishOutOfStock => dishOutOfStock.dishId === dishId,
    );

    const quantityDishAvailable = dishOutOfStockCurrent ? 0 : quantityDish;

    const totalPrice = quantityDishAvailable * totalPriceValue;

    return (
      <React.Fragment>
        {listTopping.map((topping) => {
          const {
           id: toppingId, price, quantity, name,
          } = topping;
          const currentOfStock = listToppingOutOfStock.find(
            toppingItem => toppingItem.toppingId === toppingId,
          );
          const isOutOfStock = !isEmptyObject(currentOfStock);
          const outOfStockObj = {
            orderDishId,
            toppingId,
          };
          const toppingChangePrice = listToppingPrice.find(
            toppingItem => toppingItem.toppingId === toppingId,
          );
          const toppingValue = !isEmptyObject(toppingChangePrice)
            ? toppingChangePrice.price
            : price;
          const totalValue = toppingValue * quantity;
          return (
            <PageTableRow key={toppingId}>
              <PageTableCell textAlign="center" />
              <PageTableCell textAlign="left">{name}</PageTableCell>
              <PageTableCell textAlign="center">
                <span className="font12">{quantity}</span>
              </PageTableCell>
              <PageTableCell textAlign="center">
                <NowInputPrice
                  value={toppingValue}
                  handleChangePriceOrder={handleChangePriceOrder}
                  orderDishId={orderDishId}
                  dishId={dishId}
                  toppingId={toppingId}
                />
              </PageTableCell>
              <PageTableCell textAlign="center">
                <span className="font12">{formatCurrency(totalValue)}</span>
              </PageTableCell>
              <PageTableCell textAlign="center">
                <OutOfStockItem
                  isOutOfStock={isOutOfStock}
                  handleOpenOutOfStockModal={handleOpenOutOfStockModal}
                  currentOfStock={currentOfStock}
                  isHaveChangeOrder
                  outOfStockObj={outOfStockObj}
                />
              </PageTableCell>
            </PageTableRow>
          );
        })}
        <PageTableRow>
          <PageTableCell />
          <PageTableCell textAlign="right" className="font-weight-bold">
            {trans('mod_detail_total')}
          </PageTableCell>
          <PageTableCell
            textAlign="center"
            className="font-weight-bold"
            colSpan="4"
          >
            <span className="text-green">{quantityDishAvailable} x </span>
            {`${formatCurrency(totalPriceValue)} = `}
            <strong>{formatCurrency(totalPrice)}</strong>
          </PageTableCell>
        </PageTableRow>
      </React.Fragment>
    );
  };

  render() {
    const { itemDish } = this.props;
    const table = {
      itemList: [itemDish],
      totalSize: 1,
    };

    return (
      <PageTable
        renderHeader={RejectOrderDishEditTable.renderHeader}
        renderRow={this.renderRow}
        table={table}
        isPagination={false}
        renderExtraRowInfo={this.renderExtraRowInfo}
        isShowFooter={false}
      />
    );
  }
}
export default RejectOrderDishEditTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/components/RejectOrderDishEditTable.jsx